class RedirectOrgService extends Error {
  constructor(message, ...args) {
    const msg = 'need to redirect to org service';

    super(message || msg, ...args);
    this.name = 'RedirectOrgService';

    Error.captureStackTrace(this, RedirectOrgService);
  }
}

export default RedirectOrgService;
